import { Autocomplete } from "stimulus-autocomplete";

export default class extends Autocomplete {
  connect() {
    console.log("autocomplete_controller attached");
    super.connect();
  }

  showAll() {
    if (this.inputTarget.value === "") {
      const query = this.inputTarget.value || "";
      this.fetchResults(query);
    }
  }

  get minLength() {
    return 0;
  }
}
